import { Code, Heading, Wrap, WrapItem } from '@chakra-ui/react'
import React from 'react'
import { COLORS } from '../../util/utility'

const DataPoints = () => {
    const dataPoints = [
        "name",
        "email",
        "phonenumber",
        "linkedinurl",
        "github",
        "visainformation",
        "address",
        "awards",
        "yoe",
        "skills",
        "education",
        "certifications",
        "workexperience",
        "qualification",
        "orgname",
        "yearsinorg",
        "projectname"
    ]
    return (
        <Wrap align='center'>
            <WrapItem>
                <Heading size='md'>Data points: </Heading>
            </WrapItem>
            {
                dataPoints.map((dp, indx) => <WrapItem key={indx}> <Code colorScheme={COLORS[Math.floor(Math.random() * COLORS.length)]} children={dp} /> </WrapItem>)
            }
        </Wrap>
    )
}

export default React.memo(DataPoints)